import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './smart';
import './App.css';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App/>
  
);




